import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 53,
    seconds: 10
  });
  useEffect(() => {
    const savedEndTime = localStorage.getItem('kitProgEndTime');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
      if (Date.now() > endTime) {
        endTime = Date.now() + 23 * 60 * 60 * 1000 + 53 * 60 * 1000 + 10 * 1000;
        localStorage.setItem('kitProgEndTime', endTime.toString());
      }
    } else {
      endTime = Date.now() + 23 * 60 * 60 * 1000 + 53 * 60 * 1000 + 10 * 1000;
      localStorage.setItem('kitProgEndTime', endTime.toString());
    }
    const interval = setInterval(() => {
      const difference = endTime - Date.now();
      if (difference <= 0) {
        const newEnd = Date.now() + 23 * 60 * 60 * 1000 + 53 * 60 * 1000 + 10 * 1000;
        localStorage.setItem('kitProgEndTime', newEnd.toString());
        return;
      }
      setTimeLeft({
        hours: Math.floor(difference / (1000 * 60 * 60) % 24),
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex items-center justify-center gap-2 font-montserrat font-extrabold text-2xl md:text-3xl ${className}`} data-id="element-40">
      <div className="bg-brand-dark/60 px-3 py-1.5 rounded-xl border border-current/20 flex flex-col items-center min-w-[58px]" data-id="element-41">
        <span data-id="element-42">{fmt(timeLeft.hours)}</span>
        <span className="text-[8px] opacity-70 font-sans font-medium uppercase tracking-wider" data-id="element-43">
          horas
        </span>
      </div>
      <div className="bg-brand-dark/60 px-3 py-1.5 rounded-xl border border-current/20 flex flex-col items-center min-w-[58px]" data-id="element-44">
        <span data-id="element-45">{fmt(timeLeft.minutes)}</span>
        <span className="text-[8px] opacity-70 font-sans font-medium uppercase tracking-wider" data-id="element-46">
          min
        </span>
      </div>
      <div className="bg-brand-dark/60 px-3 py-1.5 rounded-xl border border-current/20 flex flex-col items-center min-w-[58px]" data-id="element-47">
        <span data-id="element-48">{fmt(timeLeft.seconds)}</span>
        <span className="text-[8px] opacity-70 font-sans font-medium uppercase tracking-wider" data-id="element-49">
          seg
        </span>
      </div>
    </div>;
}